<template>
    <router-view></router-view>
</template>

<script>
import { App } from '@capacitor/app';
import { Dialog } from '@capacitor/dialog'; // Importation du plugin Dialog
import { useRouter } from 'vue-router';

export default {
    setup() {
        const router = useRouter();

        // Gérer le bouton retour sur Android
        App.addListener('backButton', () => {
            const currentPath = router.currentRoute.value.path;

            // Si on est sur la page d'accueil ou la page login, demander confirmation avant de quitter
            if (currentPath === '/home' || currentPath === '/') {
                // Afficher la fenêtre native de confirmation
                Dialog.confirm({
                    title: 'Confirmation',
                    message: 'Souhaitez-vous réellement quitter l\'application Argos ?',
                    okButtonTitle: 'OK',
                    cancelButtonTitle: 'Annuler'
                }).then((result) => {
                    if (result.value) {
                        App.exitApp(); // Fermer l'application si l'utilisateur clique sur OK
                    }
                });
            } else {
                router.back(); // Revenir en arrière dans l'historique de navigation
            }
        });
    },
    name: 'App',
    mounted() {
        document.title = "Argos";
    }
}
</script>

<style>
/* Update the bootstrap elements styles */
.btn-primary {
    color: #fff !important;
    background: #386bc0 !important;
    border-color: #386bc0 !important;
    box-shadow: 0 8px 9px -4px rgba(59, 113, 202, 0.3), 0 4px 18px 0 rgba(59, 113, 202, 0.2) !important;
}

.btn-primary:hover {
    background: #386bc0 !important;
    border-color: #386bc0 !important;
}
</style>
